import { render, staticRenderFns } from "./healthManagement.vue?vue&type=template&id=bc9be48e&scoped=true"
import script from "./healthManagement.vue?vue&type=script&lang=js"
export * from "./healthManagement.vue?vue&type=script&lang=js"
import style0 from "./healthManagement.vue?vue&type=style&index=0&id=bc9be48e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc9be48e",
  null
  
)

export default component.exports